import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Box, Image, Text, Button, VStack, HStack, Stack } from '@chakra-ui/react';
import { getItemById } from '../../../api/item';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import Api from '../../../api/ApiUrl'

const ItemDetails = () => {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery(['item', itemId], () => getItemById(itemId));

  if (isLoading) {
    return <Box>Loading...</Box>;
  }

  if (error) {
    return <Box>Error: {error.message}</Box>;
  }

  const item = data.data.data;

  return (
    <Box p={5}>
      <VStack spacing={5} align="start">
        <Image
          src={`${Api}/${item?.coverphoto?.path}`}
          alt={item.name}
          boxSize="400px"
          objectFit="cover"
        />
        <Text fontSize="2xl" fontWeight="bold">{item.name}</Text>
        <Text>{item.description}</Text>
        <Text>Start Price: LE{item.mainlystartPrice}</Text>
        <Text>commission: % {item.commission1}</Text>
        <Text>commission: % {item.commission2}</Text>
        <Text>commission: % {item.commission3}</Text>


        <Text>Minimum Bid Increment: ${item.minBidIncrement}</Text>
        <Text>Start Date: {new Date(item.subcategoryId.startDate).toLocaleString()}</Text>
        <Text>End Date: {new Date(item.subcategoryId.endDate).toLocaleString()}</Text>
        <Button onClick={() => navigate(`/items/${itemId}/history`)}>View Bidding History</Button>
        <Text fontSize="xl" fontWeight="bold">Thumbnail Photos</Text>
        <Box w="100%">
          <Swiper spaceBetween={10} slidesPerView={1} pagination={{ clickable: true }}>
            {item.thubnailphoto.map(photo => (
              <SwiperSlide key={photo._id}>
                <Image src={`${Api}/${photo?.path}`} alt={photo.name} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
        <Text fontSize="xl" fontWeight="bold">Auctions Details</Text>
        <VStack spacing={2} align="start">
          <Text>Name: {item.subcategoryId.name}</Text>
          <Text>Description: {item.subcategoryId.description}</Text>
          <Text>Deposit: {item.subcategoryId.deposit}</Text>
          <Text>Category Name: {item.subcategoryId.categoryId.name}</Text>
        </VStack>
        <Text fontSize="xl" fontWeight="bold">Related Items</Text>
        <Stack spacing={4}>
          {item.subcategoryId.items.map(relatedItem => (

            <HStack as={Link} to={`/dashboard/admin/item-details/${relatedItem._id}`} key={relatedItem._id} spacing={4}>
              <Image
                src={`${Api}/${relatedItem?.coverphoto?.path}`}
                alt={relatedItem.name}
                boxSize="100px"
                objectFit="cover"
              />
              <Text>{relatedItem.name}</Text>
            </HStack>
          ))}
        </Stack>
      </VStack>
    </Box>
  );
};

export default ItemDetails;
